import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPngConverterConfig } from '@/data/landingConfig/landingPngConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PngConverter } from './schemaObject';

interface Props {}
const PngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PngConverter} />
			<LandingTemplate
				data={landingPngConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default PngConverter;
